import persist from './persist'
import axios from 'axios'
// import { axapi } from '../helpers/axinstance'
// import router from '../router/index'

export default {
  state: {
  },
  mutations: {
    LOGIN (state, data) {
      state.profile.num = data.num
      state.profile.rowkey = data.rowkey
      state.profile.email = data.email
      state.profile.name = data.name
      state.profile.token = data.token
      state.authToken = data.token
      state.isLoggedIn = true
      state.isSuperAdmin = data.isSuperAdmin
      state.profile.permissions = data.permissions
      state.lastUpdated = Date.now()
    },
    LOGOUT (state) {
      state.isLoggedIn = false
      state.profile = {}
      state.servers = []
      state.selectedServer = null
      state.authToken = null
      state.lastUpdated = null
    },
  },
  actions: {
    async getOrganizationMembers ({ dispatch, commit, rootState }, payload) {
      try {
        console.log(axios.headers)
        const response = await axios.get(process.env.VUE_APP_API_URL + `/api/v1/organization/${payload}/members`)
        console.log(response)
        return response.data
      } catch (e) {
        await dispatch('processAxiosError', e)
      }
    },
  },
  getters: {
  },
  plugins: [persist.plugin],
}
